<template>
  <div class="chat">
    <div class="chat-btns" @click="handleChatClick">
      <img src="@/assets/images/help_dark.svg" class="chat-icon">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    handleChatClick() {
      this.$router.push('/kefu')
    },
  }
}
</script>

<style lang="less" scoped>
.chat {
  bottom: 30px;
  position: fixed;
  right: 30px;
  z-index: 9999;
}

.chat-btns {
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  align-items: center;
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 50%;
  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, .3);
  box-shadow: 0 2px 8px rgba(0, 0, 0, .3);
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 56px;
  justify-content: center;
  position: relative;
  -webkit-transition: all .3s ease;
  transition: all .3s ease;
  width: 56px;
}

.chat-btns:hover {
  background: #2a2a2a;
  border-color: #8ddf29;
  -webkit-box-shadow: 0 4px 12px rgba(255, 211, 15, .2);
  box-shadow: 0 4px 12px rgba(255, 211, 15, .2);
  -webkit-transform: translateY(-2px);
  transform: translateY(-2px)
}

.chat-btns:active {
  -webkit-transform: translateY(0);
  transform: translateY(0)
}

.chat-icon {
  height: 28px;
  opacity: .9;
  width: 28px
}

.chat-btns:hover .chat-icon {
  opacity: 1
}
</style>
